exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-description-modal .modal-footer{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.content-description-modal .line+.line{margin-top:15px;padding-top:15px;border-top:1px solid #e9ebec}.content-description-modal .line .form-text{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e8466fe","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/ContentDescriptionModal2.vue
// module id = csSN
// module chunks = 1